import React from "react";
import { Grid, GridColumn } from "@atlassiansox/microscopekit";
import SectionMessage from "@atlaskit/section-message";
import { BaselineCard } from "./BaselineCard";
import Saturation from "../../../images/saturation.jpeg";
import Latency from "../../../images/latency.jpeg";
import ErrorPer from "../../../images/error.jpeg";
import Traffic from "../../../images/traffic.jpeg";
var baselineHelpLink = "http://go/baseline";
var BaselinePending = function () { return (React.createElement(SectionMessage, null, "Baseline metric calculations may take a while and will be updated once completed")); };
var BaselineContent = function (_a) {
    var _b, _c;
    var data = _a.data;
    var goldenSignals = [
        {
            id: "1",
            type: "Saturation",
            metrics: [
                { key: "CPU", value: "CPU Utilization" },
                { key: "Memory", value: "Memory Utilization" }
            ],
            img: Saturation,
            unit: "%"
        },
        {
            id: "2",
            type: "Latency",
            metrics: [{ key: "P99", value: "Latency P99" }],
            img: Latency,
            unit: "ms"
        },
        {
            id: "3",
            type: "Traffic",
            metrics: [{ key: "Traffic_2xx", value: "Requests_2xx" }],
            img: Traffic,
            unit: ""
        },
        {
            id: "4",
            type: "Error",
            metrics: [
                { key: "Error_4xx", value: "Requests_4xx" },
                { key: "Error_5xx", value: "Requests_5xx" }
            ],
            img: ErrorPer,
            unit: ""
        }
    ];
    return (React.createElement("div", null,
        React.createElement(SectionMessage, null,
            "The Golden Baseline metrics are calculated from",
            " ", (_b = data.baselineForService) === null || _b === void 0 ? void 0 :
            _b.environment,
            " SignalFx metric of past 7 days. Last updated ", (_c = data.baselineForService) === null || _c === void 0 ? void 0 :
            _c.staleness,
            " days ago.",
            React.createElement("br", null),
            "Use it to configure faults and steady states.",
            React.createElement("a", { href: baselineHelpLink, target: "_blank", rel: "noopener noreferrer" }, "\u00A0Learn more")),
        React.createElement("br", null),
        React.createElement(GridColumn, { medium: 12 },
            React.createElement(Grid, { layout: "flex" }, goldenSignals.map(function (signal) { return (React.createElement(BaselineCard, { goldenSignal: signal.type, img: signal.img, metrics: signal.metrics, data: data.baselineForService, unit: signal.unit })); })))));
};
export var BaselinePanel = function (props) {
    var data = props.baseline;
    return (React.createElement("div", null,
        React.createElement("h4", null, "Baseline Metrics"),
        React.createElement("br", null),
        (data === null || data === void 0 ? void 0 : data.baselineForService) ? (React.createElement(BaselineContent, { data: data })) : (React.createElement(BaselinePending, null))));
};
